var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"spinner",class:{
    'margin-left': _vm.marginLeft,
    'margin-right': _vm.marginRight,
  }},[_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"fa-solid fa-spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }